var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"review__image-wrap"},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"review__image"},[_c('img',{attrs:{"src":_vm.getUrl(image.base_url),"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }